<template>
  <v-layout style="max-width: 100%;">
    <v-avatar class="shrink mx-2 my-1" size="15">
      <img v-if="iconExists" :src="webpage.icon" alt="site logo" @error="iconExists = false" />
    </v-avatar>
    <v-layout column>
      <div class="truncate">
        <span class="subheading font-weight-bold">{{ webpage.title }}</span>
      </div>
      <v-layout align-content-start>
        <div class="caption pr-2">
          {{ webpage.provider }}
        </div>
        <div class="caption pl-2">
          <v-icon x-small>label</v-icon>
          <template v-for="tag in resource.tags.userDefined">
            {{ tag.text }}
          </template>
        </div>
      </v-layout>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  props: {
    resource: { default: () => ({}) },
    webpage: { default: () => ({}) }
  },
  data() {
    return {
      iconExists: true
    };
  }
};
</script>

<style>
.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}</style>
